import {Button, Divider, Stack} from '@mui/material';
import React, {Fragment} from 'react';

import {Snackbar} from 'presentation/components';
import {translations} from 'presentation/translations-new';

import {PhonesDrawer} from 'presentation/components/PhonesDrawer';
import {PhonesMenu} from 'presentation/components/PhonesMenu';

import {UnitDetailsDrawer} from 'presentation/pages/private/booking/components/UnitDetailsDrawer';

import {useUnitCard} from '../../hooks/useUnitCard';
import {StyledButton} from './styles';
import {UnitCardActionsProps} from './types';

const {showDetails, call, book} = translations['pt-br'].commons;
const {emptyPhone, choosePhoneNumber} =
	translations['pt-br'].privateFlow.bookingFlow.unitsFlow.unitDetails;

export function UnitCardActions({
	address,
	unitName,
	isTelemedicine,
	onClick,
	isNotSelf,
	nmBairroOrigem,
	phoneNumbers,
	specialtyName,
	showDetailsDataTagId,
	callDataTagId,
	bookDataTagId,
}: UnitCardActionsProps) {
	const {
		isPhoneNumberMenuOpen,
		showPhonesDrawer,
		handleCloseSnackbar,
		handleOpenPhoneMenu,
		handleClosePhoneMenu,
		handleTogglePhoneDrawer,
		addressToDisplay,
		handleToggleDetailsDrawer,
		openPhoneDrawerState,
		showEmptyPhoneSnackbar,
		showDetailsDrawerState,
		anchorEl,
		setShowDetailsDrawerState,
	} = useUnitCard({
		isTelemedicine,
		isNotSelf,
		nmBairroOrigem,
		phoneNumbers,
		address,
	});

	return (
		<Fragment>
			<Stack>
				<Divider />
				<Stack px={2} py={1}>
					{!isNotSelf ? (
						<Stack
							direction="row"
							alignItems={'center'}
							justifyContent={'space-between'}
							gap={1}>
							<Button
								color={'primary'}
								variant={'contained'}
								size="small"
								onClick={onClick}
								data-tag-id={bookDataTagId}
								sx={{alignSelf: 'flex-end', boxShadow: 'none', ml: 'auto'}}>
								{book}
							</Button>
						</Stack>
					) : (
						<Stack direction="row" gap={1}>
							<Stack ml="auto" direction="row" gap={1}>
								<StyledButton
									onClick={handleToggleDetailsDrawer}
									data-tag-id={showDetailsDataTagId}
									variant="outlined"
									size="small">
									{showDetails}
								</StyledButton>
								<StyledButton
									variant="contained"
									size="small"
									onClick={handleOpenPhoneMenu}
									data-tag-id={callDataTagId}
									sx={{minWidth: 0}}>
									{call}
								</StyledButton>
							</Stack>
						</Stack>
					)}
				</Stack>
			</Stack>

			{phoneNumbers?.length ? (
				<PhonesMenu.Root
					open={isPhoneNumberMenuOpen}
					onClose={handleClosePhoneMenu}
					anchorEl={anchorEl}>
					<PhonesMenu.Simple phoneNumbers={phoneNumbers} />
				</PhonesMenu.Root>
			) : (
				<Snackbar
					onClose={handleCloseSnackbar}
					message={emptyPhone}
					open={showEmptyPhoneSnackbar}
				/>
			)}

			{showPhonesDrawer ? (
				<PhonesDrawer.Root
					open={openPhoneDrawerState}
					toggleDrawer={handleTogglePhoneDrawer}
					title={choosePhoneNumber}>
					<PhonesDrawer.Simple phoneNumbers={phoneNumbers ?? []} />
				</PhonesDrawer.Root>
			) : null}

			{showDetailsDrawerState ? (
				<UnitDetailsDrawer
					open={showDetailsDrawerState}
					onOpen={() => setShowDetailsDrawerState(true)}
					onClose={() => setShowDetailsDrawerState(false)}
					address={addressToDisplay}
					phoneNumbers={phoneNumbers}
					specialtyName={specialtyName}
					unitName={unitName}
				/>
			) : null}
		</Fragment>
	);
}
